<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-body">
            <canvas width="800" height="250"/>
        </div>
    </div>
</template>


<script>
    const totalizer = {
        id: 'totalizer',

        beforeUpdate: chart => {
            let totals = {}
            let utmost = 0

            chart.data.datasets.forEach((dataset, datasetIndex) => {
                if (chart.isDatasetVisible(datasetIndex)) {
                    utmost = datasetIndex

                    dataset.data.forEach((value, index) => {
                        totals[index] = (totals[index] || 0) + value
                    })
                }
            })

            chart.$totalizer = {
                totals: totals,
                utmost: utmost
            }
        }
    }

    import http from '@/http'
    import Chart from "chart.js";
    import datalabels from "chartjs-plugin-datalabels";

    export default {
        props: {
            filters: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                data: null,

                chart: null
            }
        },

        mounted() {
            this.load().then(this.draw)
        },

        watch: {
            filters: {
                deep: true,
                handler: function (value, oldValue) {
                    if (value.category !== oldValue.category || value.user_id !== oldValue.user_id || value.is_new_business !== oldValue.is_new_business) {
                        this.load().then(this.draw)
                    }
                }
            }
        },

        methods: {
            load() {
                return http.post('/api/v1/reports/meeting-by-week', this.filters)
                    .then(response => {
                        this.data = response.data.data
                    })
            },

            draw() {
                if (this.chart) {
                    this.chart.destroy()
                }

                this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
                    plugins: [datalabels, totalizer],

                    type: 'bar',

                    data: {
                        labels: this.data.map(row => row.week),
                        datasets: [
                            {
                                label: 'Sales',
                                data: this.data.map(row => row.sales_count),
                                backgroundColor: '#62d26f',
                                borderColor: '#62d26f',
                                fill: false
                            },
                            {
                                label: 'Opportunities',
                                data: this.data.map(row => row.opportunity_count),
                                backgroundColor: '#eec300',
                                borderColor: '#eec300',
                                fill: false
                            },
                            {
                                label: 'Booked Meetings',
                                data: this.data.map(row => row.booked_meeting_count),
                                backgroundColor: '#fd9a00',
                                borderColor: '#fd9a00',
                                fill: false
                            },
                            {
                                label: 'Held Meetings',
                                data: this.data.map(row => row.held_meeting_count),
                                backgroundColor: '#e8384f',
                                borderColor: '#e8384f',
                                fill: false
                            }
                        ]
                    },

                    options: {
                        scales: {
                            xAxes: [{
                                stacked: true
                            }],
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },

                        layout: {
                            padding: {
                                top: 25
                            }
                        },

                        legend: {
                            position: 'bottom'
                        },

                        plugins: {
                            datalabels: {
                                anchor: 'end',
                                align: 'end',
                                formatter: (value, ctx) => ctx.chart.$totalizer.totals[ctx.dataIndex],
                                display: (ctx) => ctx.datasetIndex === ctx.chart.$totalizer.utmost
                            }
                        },

                        onClick: (event, elements) => {
                            if (elements.length) {
                                this.$emit('update:filters', {
                                    ...this.filters,
                                    starts_from: this.data[elements[0]['_index']].start_date,
                                    starts_to: this.data[elements[0]['_index']].end_date
                                })
                            }
                        }
                    }
                })
            }
        }
    }
</script>
